export const BACKUP_CODE_GENERATED = 'BackupCodeGenerated';
export const CACHE_CLEARED = 'CacheCleared';
export const CONNECTION_LOSS_NOTIFICATION_SHOWN = 'ConnectionLossNotificationShown';
